"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addNavigators = void 0;
var LvFalconNavigator_1 = require("./LvFalconNavigator");
var LvFalconNavigatorNoProgressBar_1 = require("./LvFalconNavigatorNoProgressBar");
var LvFalconNavigatorNoBackground_1 = require("./LvFalconNavigatorNoBackground");
var LvFalconNavigatorShowLock_1 = require("./LvFalconNavigatorShowLock");
var LvFalconNavigatorNoBackgroundNoProgressBar_1 = require("./LvFalconNavigatorNoBackgroundNoProgressBar");
var LvFalconNavigatorNoTitle_1 = require("./LvFalconNavigatorNoTitle");
var LvFalconNavigatorWithArrowBackButtons_1 = require("./LvFalconNavigatorWithArrowBackButtons");
var LvFalconNavigatorWithArrowBackAnchors_1 = require("./LvFalconNavigatorWithArrowBackAnchors");
var LvAnnualMotorNavigator_1 = require("./LvAnnualMotorNavigator");
var LvAnnualNBNavigator_1 = require("./LvAnnualNBNavigator");
var LvAnnualRenewalDeclineNavigator_1 = require("./LvAnnualRenewalDeclineNavigator");
var LvAnnualMotorNavigatorNoTitle_1 = require("./LvAnnualMotorNavigatorNoTitle");
var LvAnnualRenewalDeclineNavigatorNoCancelButton_1 = require("./LvAnnualRenewalDeclineNavigatorNoCancelButton");
var LvFalconNavigatorNoBackgroundNoTitle_1 = require("./LvFalconNavigatorNoBackgroundNoTitle");
var LvBritanniaNavigatorWithArrowBackButtons_1 = require("./LvBritanniaNavigatorWithArrowBackButtons");
var addNavigators = function (extensions) {
    extensions.journeyComponents.addNavigatorComponent({
        id: "falcon",
        component: LvFalconNavigator_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoProgressBar",
        component: LvFalconNavigatorNoProgressBar_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoBackground",
        component: LvFalconNavigatorNoBackground_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoBackgroundNoTitle",
        component: LvFalconNavigatorNoBackgroundNoTitle_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconShowLock",
        component: LvFalconNavigatorShowLock_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualMotorNavigatorNoTitle",
        component: LvAnnualMotorNavigatorNoTitle_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoTitle",
        component: LvFalconNavigatorNoTitle_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconNoBackgroundNoProgressBar",
        component: LvFalconNavigatorNoBackgroundNoProgressBar_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconWithArrowBackButtons",
        component: LvFalconNavigatorWithArrowBackButtons_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "falconWithArrowBackAnchors",
        component: LvFalconNavigatorWithArrowBackAnchors_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualMotorNavigator",
        component: LvAnnualMotorNavigator_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualNBNavigator",
        component: LvAnnualNBNavigator_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualMotorRenewalDeclineNavigator",
        component: LvAnnualRenewalDeclineNavigator_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "annualRenewalDeclineNavigatorNoCancelButton",
        component: LvAnnualRenewalDeclineNavigatorNoCancelButton_1.default
    });
    extensions.journeyComponents.addNavigatorComponent({
        id: "britanniaNavigatorWithArrowBackButtons",
        component: LvBritanniaNavigatorWithArrowBackButtons_1.default
    });
};
exports.addNavigators = addNavigators;
//# sourceMappingURL=index.js.map